import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Supplier } from './supplier';
import { Branch } from '../../accounting/branch';
import { Utils } from 'services/utils.service';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { Configuration } from '../../../app.constants';

@Injectable()
export class SupplierService {
  private supplierApiUrl: string = this._configuration.apiUrl + '/v2/supplier';
  private supplierApiBranchUrl: string = this._configuration.apiUrl + '/v2/supplierbranch';

  constructor(public _authService: AuthenticationService,
    private _configuration: Configuration,
    private _http: Http) { }

  getSuppliers(): Observable<Supplier[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    return this._http.get(this.supplierApiUrl, { headers: h, search: s }).map((response: Response) => response.json().suppliers);
  }

  getSupplier(id: number): Observable<Supplier> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', id + '');

    return this._http.get(this.supplierApiUrl, { headers: h, search: s }).map((response: Response) => response.json().suppliers[0]);
  }

  saveSupplier(supplier: Supplier): Observable<any> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    if (supplier.id) {
      s.append('id', supplier.id + '');

      return this._http.put(this.supplierApiUrl, supplier, { headers: h, search: s }).map((response: Response) => response.json());
    } else {
      return this._http.post(this.supplierApiUrl, supplier, { headers: h, search: s }).map((response: Response) => response.json());
    }
  }

  deleteSupplier(supplierId: number): Observable<any> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', supplierId + '');

    return this._http.delete(this.supplierApiUrl, { headers: h, search: s }).map((response: Response) => response);
  }

  saveSupplierBranch(supplierId: number, branchId: number): Observable<any> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('supplier_id', supplierId + '');
    s.append('branch_id', branchId + '');

    return this._http.post(this.supplierApiBranchUrl, {}, { headers: h, search: s }).map((response: Response) => response.json());
  }

  deleteSupplierBranch(supplierId: number, branchId: number): Observable<any> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('supplier_id', supplierId + '');
    s.append('branch_id', branchId + '');

    return this._http.delete(this.supplierApiBranchUrl, { headers: h, search: s }).map((response: Response) => response);
  }

  getSupplierPrefixes(branch?: string): Observable<Supplier[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('names', 'true');
    if (branch != null) {
        s.append('branch', branch);
    }

    return this._http.get(this.supplierApiUrl, { headers: h, search: s }).map(
        response => {
            let body = response.json();
            if (body == null || !Array.isArray(body))
                return [];

            //Make IDs numbers instead of strings
            body.forEach((s) => { s.id = Number.parseInt(s.id) });
            return body;
        }
    );
}
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/purchasing/suppliers/supplier.service.ts